import { render, staticRenderFns } from "./purchase-card.vue?vue&type=template&id=46d83bfa&scoped=true"
import script from "./purchase-card.vue?vue&type=script&lang=js"
export * from "./purchase-card.vue?vue&type=script&lang=js"
import style0 from "./purchase-card.vue?vue&type=style&index=0&id=46d83bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d83bfa",
  null
  
)

export default component.exports